/**
 * Created by Administrator on 2018/8/4 0004.
 */

export default {
  state: {
    //
  },
  getters: {

  },
  actions: {

  },
  mutations: {

  }
}



// WEBPACK FOOTER //
// ./src/store/modules/users.js